import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { OuterWrapperProps } from '@widgets/Teaser/toi/types'
import Blink from '@components/Blink'

const StyledOuterWrapper = styled(Blink)`
  display: block;
  position: relative;
  cursor: pointer;
  text-decoration: none;
  overflow: hidden;
`

const OuterWrapper: FunctionComponent<OuterWrapperProps> = ({
  children,
  clickableProps,
}) => {
  return (
    <StyledOuterWrapper
      {...(clickableProps as unknown as { href: string } & Record<
        string,
        unknown
      >)}>
      {children}
    </StyledOuterWrapper>
  )
}

export default OuterWrapper
